//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import work_bench_item from "@/components/work_bench_item";
export default {
  components: { work_bench_item },
  data() {
    return {
      indexData: {},
      actionTitle:'',
      actionList: [],
      showActionSheet: false,
      actionSheet1: {
        title: '采购入库',
        actions: [
          { 
            name: '1.采购入库单',
            // url: "this.$api.host+'/mDms/DealerStockInBuyOrder'"
            link:"/YslDms/DealerStockInOrder/Index"
           },
          { 
            name: '2.采购入库明细',
            // url: this.$api.host+'/mDms/DealerStockInBuyOrder/DetailIndex' 
            link:"/YslDms/DealerStockInOrder/DetailIndex"
          },
        ],
      },
      actionSheet2: {
        title: '销售出库',
        actions: [
           { 
            name: '1.销售出库单', 
            // url: this.$api.host+'/mDms/DealerStockOutSalesOrder' 
            link:"/YslDms/DealerStockOutOrder/Index"
            },
          { 
            name: '2.销售出库明细', 
            // url: this.$api.host+'/mDms/DealerStockOutSalesOrder/DetailIndex'
            link:"/YslDms/DealerStockOutOrder/DetailIndex"
          },
        ],
      },
      actionSheet3: {
        title: '库存盘点',
        actions: [
           { 
            name: '1.库存盘点单', 
            // url: this.$api.host+'/mDms/DealerStockOutSalesOrder' 
            link:"/YslDms/DealerStockCheckOrder/Index"
            },
          { 
            name: '2.库存盘点明细', 
            // url: this.$api.host+'/mDms/DealerStockOutSalesOrder/DetailIndex'
            link:"/YslDms/DealerStockCheckOrder/DetailIndex"
          },
        ],
      },
      work_bench_item1: [
        {
          img: "images/1_30.png",
          text: "库存查看",
          link: "/YslDms/DealerStockDataDetail/Index",
        },
        {
          img: "images/1_26.png",
          text: "门店库存",
          link:"/YslDms/ShopStockDataDetail/ShopIndex",
          hide_border: true
        }
      ],
      work_bench_item2: [
        {
          img: "images/1_15.png",
          text: "采购入库单",
          action: 'saleCheckinOrder',
          hide_border: true
        },
      ],
      work_bench_item3: [
        {
          img: "images/1_19.png",
          text: "销售出库单",
          action: 'saleCheckoutOrder',
        },
        {
          img: "images/1_23.png",
          text: "兑换出库单",
          link: "/YslDms/DealerStockOutExchangeOrder/Index",
          hide_border: true
        }
      ],
      work_bench_item4: [
        {
          img: "images/1_26.png",
          text: "库存盘点单",
          // link: "/YslDms/DealerStockCheckOrder/Index",
          // hide_border: true
          action: 'saleCheckcheckOrder',
          hide_border: true
        },
      ],
      work_bench_item5: [
        {
          img: "images/1_26.png",
          text: "会员兑换单(门店提货)",
          link: "/YslSms/MemberUserPointsOutExchangeOrderForShop/Index"
        },
        {
          img: "images/2_10.png",
          text: "兑换补货单",
          link: this.$api.host+"/mDms/DealerReplenishmentOrder",
          hide_border: true
        }
      ],
    };
  },
  computed: {},

  async onLoad() {
  },

  created () {
  },

  methods: {
    saleCheckinOrder () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet1.title
      this.actionList = this.actionSheet1.actions
    },
    saleCheckoutOrder () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet2.title
      this.actionList = this.actionSheet2.actions
    },
    saleCheckcheckOrder () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet3.title
      this.actionList = this.actionSheet3.actions
    },
    onSelect (item) {
      console.log(item)
      if (item.link) {
        if (item.link.indexOf('http') == -1) {
          this.$router.push(item.link)
        } else {
          window.location = item.link
          this.$toast({
            type: 'loading',
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '加载中'
          })
        }
      }
    }
  }
};
